let selectedBike = "";
let selectedItems = [];
let selectedTemplate = "";
let total = 0;

const builder =
document.getElementById(
"builder-content"
);

const summary =
document.getElementById(
"summary-content"
);

const totalText =
document.getElementById(
"builder-total"
);

const products = {

  ultra:[
    {name:"Front Plate",price:450,handle:"ultra-front-plate-decal"},
    {name:"Fork Guards",price:450,handle:"ultra-fork-guards"},
    {name:"Front Fender",price:500,handle:"ultra-front-fender"},
    {name:"Rear Fender",price:450,handle:"ultra-rear-fender"},
    {name:"Side Panels",price:1250,handle:"ultra-side-panels"},
    {name:"Plastics Only",price:2500,handle:"ultra-plastics-only"},
    {name:"Full Bike Kit",price:3800,handle:"ultra-full-bike-kit"}
  ],

  light:[
    {name:"ODI Plate",price:350,handle:"odi-decal"},
    {name:"Fork Guards",price:400,handle:"light-bee-fork-guards"},
    {name:"Battery Cover",price:400,handle:"light-bee-battery-cover"},
    {name:"Front Fender",price:450,handle:"light-bee-front-fender"},
    {name:"Rear Fender",price:300,handle:"light-bee-rear-fender"},
    {name:"Plastics Only",price:1500,handle:"light-bee-plastics-only"},
    {name:"Full Bike Kit",price:2800,handle:"light-bee-full-bike-kit"}
  ],

  talaria:[
    {name:"ODI Plate",price:350,handle:"odi-decal"},
    {name:"Fork Guards",price:400,handle:"talaria-fork-guards"},
    {name:"Battery Cover",price:400,handle:"talaria-battery-cover"},
    {name:"Front Fender",price:450,handle:"talaria-front-fender"},
    {name:"Rear Fender",price:300,handle:"talaria-rear-fender"},
    {name:"Plastics Only",price:1500,handle:"talaria-plastics-only"},
    {name:"Full Bike Kit",price:2800,handle:"talaria-full-bike-kit"}
  ]

};

const templates = {

  ultra:[
    {
      name:"Aggressive",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/Ultra_bee_Template_Aggresive.jpg?v=1784023258"
    },
    {
      name:"Clean",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/Ultra_Bee_Template_Clean.webp?v=1784023257"
    },
    {
      name:"Custom Design",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/fx-logo.png"
    }
  ],

  light:[
    {
      name:"Aggressive",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/light_bee_template_aggresive.webp?v=1784023257"
    },
    {
      name:"Clean",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/light_bee_template_clean.jpg?v=1784023258"
    },
    {
      name:"Custom Design",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/fx-logo.png"
    }
  ],

  talaria:[
    {
      name:"Aggressive",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/talaria_template_aggresive.webp?v=1784023975"
    },
    {
      name:"Clean",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/talaria_template_clean.webp?v=1784023975"
    },
    {
      name:"Custom Design",
      img:"https://cdn.shopify.com/s/files/1/0776/8470/3405/files/fx-logo.png"
    }
  ]

};

document
.querySelectorAll(".bike-card")
.forEach(card=>{

  card.addEventListener("click",()=>{

    document
    .querySelectorAll(".bike-card")
    .forEach(
      c=>c.classList.remove("active")
    );

    card.classList.add("active");

    selectedBike =
    card.dataset.bike;

    renderBuilder();

  });

});

function renderBuilder(){

  total = 0;
  selectedItems = [];
  selectedTemplate = "";

  builder.innerHTML = `

    <h2>Products</h2>

    <div class="product-grid">

      ${products[selectedBike]
      .map(item=>`

        <div
        class="product-card"
        data-handle="${item.handle}"
        data-name="${item.name}"
        data-price="${item.price}">

          <h3>${item.name}</h3>

          <p>R${item.price}</p>

        </div>

      `).join("")}

    </div>

    <h2 style="margin-top:40px;">
      Template
    </h2>

    <div class="template-grid">

      ${templates[selectedBike]
      .map(t=>`

        <div
        class="template-card ${t.name === "Custom Design" ? "custom-template" : ""}"
        data-template="${t.name}">

          <img
          loading="lazy"
          decoding="async"
          src="${t.img}">

          <h3>${t.name}</h3>

          ${
            t.name === "Custom Design"
            ?
            `<p>Upload inspiration and we'll recreate it.</p>`
            :
            ""
          }

        </div>

      `).join("")}

    </div>

    <div class="custom-upload">

  <p class="custom-help">
    After placing your order, send your inspiration images,
    logos and proof of payment on WhatsApp together with
    your order number.
  </p>

  <a
  href="https://wa.me/27670587277"
  target="_blank"
  class="whatsapp-btn">

    Send Inspiration On WhatsApp →

  </a>

  <textarea
  id="builder-custom-notes"
  placeholder="Describe your dream design, colours, logos, rider number, etc."></textarea>

</div>

    <div class="builder-fields">

      <input
      id="builder-name"
      placeholder="Name">

      <input
      id="builder-number"
      placeholder="Number">

      <input
      id="builder-colours"
      placeholder="Colours">

      <textarea
      id="builder-notes"
      placeholder="Notes"></textarea>

    </div>

  `;

  bindEvents();

}

function bindEvents(){

  document
  .querySelectorAll(".product-card")
  .forEach(card=>{

    card.onclick = ()=>{

      const handle =
      card.dataset.handle;

      const name =
      card.dataset.name;

      const price =
      Number(card.dataset.price);

      card.classList.toggle("active");

      if(card.classList.contains("active")){

        selectedItems.push({
          handle,
          name,
          price
        });

        total += price;

      }else{

        selectedItems =
        selectedItems.filter(
          i=>i.handle !== handle
        );

        total -= price;

      }

      updateSummary();

    };

  });

  document
  .querySelectorAll(".template-card")
  .forEach(card=>{

    card.onclick = ()=>{

      document
      .querySelectorAll(".template-card")
      .forEach(
        c=>c.classList.remove("active")
      );

      card.classList.add("active");

      selectedTemplate =
      card.dataset.template;

      const upload =
      document.querySelector(
      ".custom-upload"
      );

      if(upload){

        if(
          selectedTemplate ===
          "Custom Design"
        ){
          upload.classList.add(
          "active"
          );
        }else{
          upload.classList.remove(
          "active"
          );
        }

      }

      updateSummary();

    };

  });

}

function updateSummary(){

  summary.innerHTML = "";

  selectedItems.forEach(item=>{

    summary.innerHTML += `
      <p>${item.name}</p>
    `;

  });

  if(selectedTemplate){

    summary.innerHTML += `
      <p>
      Template:
      ${selectedTemplate}
      </p>
    `;

  }

  totalText.innerHTML =
  `R${total}`;

}

async function addToCart(){

  if(selectedItems.length === 0){

    alert(
    "Select products."
    );

    return;

  }

  const cartItems = [];

  for(
    const item
    of selectedItems
  ){

    const res =
    await fetch(
    `/products/${item.handle}.js`
    );

    const product =
    await res.json();

    cartItems.push({

      id:
      product
      .variants[0]
      .id,

      quantity:1,

      properties:{

        Bike:
        selectedBike,

        Template:
        selectedTemplate,

        Name:
        document.getElementById(
        "builder-name"
        )?.value,

        Number:
        document.getElementById(
        "builder-number"
        )?.value,

        Colours:
        document.getElementById(
        "builder-colours"
        )?.value,

        Notes:
        document.getElementById(
        "builder-notes"
        )?.value,

        Reference:
        document.getElementById(
        "builder-reference"
        )?.value,

        Custom_Design_Notes:
        document.getElementById(
        "builder-custom-notes"
        )?.value

      }

    });

  }

  await fetch(
    "/cart/add.js",
    {
      method:"POST",
      headers:{
        "Content-Type":
        "application/json"
      },
      body:JSON.stringify({
        items:cartItems
      })
    }
  );

  window.location =
  "/cart";

}

document
.querySelector(
".purchase-btn"
)
.addEventListener(
"click",
addToCart
);